import React from 'react';
import './Values.css';

const values = [
  {
    num: '01',
    title: 'Люди важнее KPI',
    desc: 'Мы не строим культуру метрик. Нам важно, чтобы каждый человек в команде понимал смысл своей работы и горел ею.',
  },
  {
    num: '02',
    title: 'ИИ — инструмент, не замена',
    desc: 'Мы создаём технологию, которая усиливает человека — его мышление, возможности, время. Не вытесняет его.',
  },
  {
    num: '03',
    title: 'Честность по умолчанию',
    desc: 'Никакого корпоративного языка. Говорим прямо о проблемах, идеях и ожиданиях — это быстрее и честнее.',
  },
  {
    num: '04',
    title: 'Вовлечённость = влияние',
    desc: 'На ранней стадии каждый голос меняет продукт. Если тебе интересно — ты автоматически становишься соавтором.',
  },
];

export default function Values() {
  return (
    <section className="section" id="values" style={{ background: 'var(--bg-surface)' }}>
      <div className="container">
        <div className="values__header reveal">
          <div className="section-label">// 002 · ценности</div>
          <h2 className="section-title">Что нами движет</h2>
        </div>

        <div className="values__grid">
          {values.map((v) => (
            <div key={v.num} className="values__item reveal">
              <span className="values__num">{v.num}</span>
              <div>
                <h3 className="values__title">{v.title}</h3>
                <p className="values__desc">{v.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
